import FormMixin from '@/mixins/formvalid'
import gInput from '@/components/googlemaps/gInput';

export default {
  mixins: [FormMixin],
  props: ['dialog', 'form', 'user'],
  components: {
    'g-input': gInput
  },
  data () {
    return {
      valid: false,
      adress_notValid: false,
      fadress_notValid: false,
      menu: false,
      menu2: false,
      time: null,
      date: null,
      dateFormatted: null,
      items: [],
      invoiceAddress: false
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    save () {
      if (this.$refs.form.validate()) {
        if (this.form.address && this.form.zip && this.form.city) {
          this.$emit('save', this.form);
        } else {
          this.adress_notValid = true;
          console.log('check your address');
          console.log(this.form.address, this.form.zip, this.form.city);
        }
      }
    },
    close () {
      this.$emit('close');
    },
    toggleInvoice (v) {
      if (!v) {
        this.form.invoiceName = null;
        this.form.invoiceAddress = null;
      }
      console.log('toggleInvoice', v);
    },
    toggleFactuur (v) {
      if (!v) {
        this.form.factuur = null;
      }
      console.log('toggleFactuur', v);
    },
    setAddress (v) {
      this.form.fullAddress = v;
    },
    setInvoiceAddress (v) {
      this.form.invoiceAddress = v;
    },
    setPlace (v) {
      if (v.street_number && v.postal_code && v.route && v.locality) {
        this.form.address = v.route + ' ' + v.street_number;
        this.form.zip = v.postal_code;
        this.form.city = v.locality || '';
        this.form.latitude = v.latitude;
        this.form.longitude = v.longitude;
        this.adress_notValid = false;
      } else {
        this.adress_notValid = true;
        this.form.fullAddress = this.form.address = this.form.zip = this.form.city = null;
      }
      console.log(v);
    },
    setInvoicePlace (v) {
      if (v.street_number && v.postal_code && v.route && v.locality) {
        this.fadress_notValid = false;
      } else {
        this.fadress_notValid = true;
        this.form.invoiceAddress = null;
      }
      console.log(v);
    },
    prefill (d) {
      for (var key in d) {
        this.form[key] = d[key]; // copies each property to the form object
      }
      this.invoiceAddress = false;
      this.adress_notValid = false;
      this.fadress_notValid = false;

      if (d.fullAddress) {
        this.$nextTick(() => { this.$refs.address.update(d.fullAddress); });
      }
      if (d.invoiceAddress) {
        this.invoiceAddress = true;
        this.$nextTick(() => { this.$refs.invoice.update(d.invoiceAddress); });
      }
      if (d.invoiceName) {
        this.invoiceAddress = true;
        this.form.invoiceName = d.invoiceName;
      }
    },
    init (v) {
      if (v) {
        this.prefill(this.user);
      }
    }
  },
  watch: {
    dialog (value) {
      this.init(value);
    }
  }
}
